<template>
  <span class="hidden" aria-hidden="true" />
</template>

<script setup>
// Formulário em AuthLayout; rota nomeada para meta/guards
</script>
